import { Select, SelectOption } from '@ui/Select';

interface Props {
  options: SelectOption<string>[],
  value: SelectOption<string>,
  onChange: (option: SelectOption<string>) => void,
  className?: string,
}

export const HeaderCatalogSelect: React.FC<Props> = ({
  options,
  value,
  onChange,
  className,
}) => (
  <Select
    className={className}
    isSearchable={false}
    value={value}
    options={options}
    onChange={onChange}
    styles={{
      control: (provided) => ({
        ...provided,
        border: 'none',
        height: '40px',
        borderRight: '1px solid #eee',
        cursor: 'pointer',
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
      }),
      option: (provided) => ({
        ...provided,
        cursor: 'pointer',
        zIndex: 100,
        color: '#000',
      }),
      menu: (provided) => ({
        ...provided,
        borderRadius: '8px',
        zIndex: 140,
      }),
      indicatorSeparator: (provided) => ({
        ...provided,
        backgroundColor: '#f0f0f0',
      }),
    }}
  />
);
